module.exports = __webpack_public_path__ + "static/media/logo-2.66d8623d.png";